const synchronizationActionType = {
  SYNCHRONIZATION_SUCCESS: "SYNCHRONIZATION_SUCCESS",
  SYNCHRONIZATION_ERROR: "SYNCHRONIZATION_ERROR",
};

export default synchronizationActionType;
